import React, { useRef, useContext, useEffect, useState } from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import "./previewFullContent.scss";
import { QuestionsContextMemorySpace } from "../../../contexts/questions/questionsContext";
import dompurify from "dompurify";
import CommonLoader from "../../../components/common/loader";
import CommonNotFound from "../../../components/common/not-found";
import axios from "axios";

const PreviewFullContentComponent = () => {
  // const { question } = useContext(QuestionsContextMemorySpace);
  const [currentData, setCurrentData] = useState(null);
  const { id } = useParams(); // Capturar el id desde los parámetros de la URL
  const location = useLocation();
  const sanitizer = dompurify.sanitize;
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    axios
      .get(
        `${process.env.REACT_APP_STRAPI_QA}/categorias?_publicationState=preview&published_at_null=true&eliminado=false`
      )
      .then((response) => {
        const foundData = response.data.find((item) =>
          item?.subCategorias.find((sub) => sub.id.toString() === id)
        );

        if (foundData) {
          const foundSubcategory = foundData.subCategorias.find(
            (sub) => sub.id.toString() === id
          );
          setCurrentData({ ...foundData, subCategoria: foundSubcategory });
        }
      })
      .catch((error) => {
        // console.log("error", error);
      });

    setLoader(false);
  }, [location.pathname, loader, id]);

  return (
    <section className="full-content-container">
      {loader ? (
        <CommonLoader></CommonLoader>
      ) : currentData ? (
        <div className="container container-padre" id="container-resultados">
          <div className="container">
            <div className="breadcrumb-containerContent">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {/* <a href="#">Centro de ayuda</a> */}
                    <Link to={`/micrositio`}>Central de Ayuda</Link>
                  </li>
                  <li
                    className="breadcrumb-item active-breadcrumb"
                    aria-current="page"
                  >
                    <Link to={`/${currentData?.slug}`}>
                      {currentData?.titulo}
                    </Link>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="row mb-3">
              <div className="col-lg-12">
                <h2 className="section_hb_title title-results">
                  <p className="titleContent">
                    {currentData?.subCategoria.titulo}
                  </p>
                </h2>
              </div>
            </div>
            <div className="preguntas-contenido">
              <div
                // className="innerHTML"
                dangerouslySetInnerHTML={{
                  __html: sanitizer(currentData?.subCategoria?.contenido),
                }}
              />
              {/* <p className="contenido">{currentData.subCategoria.contenido}</p> */}
            </div>
          </div>
        </div>
      ) : (
        <CommonNotFound pshb={false} loggedIn={true} />
      )}
    </section>
  );
};

export default PreviewFullContentComponent;
